var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F2F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3935 23.4837C43.3779 23.4555 43.356 23.4274 43.331 23.4055C43.1747 23.2493 42.9216 23.2493 42.7654 23.4055L37.381 28.7899L35.2591 26.668L40.6466 21.2805C40.6716 21.2555 40.6904 21.2305 40.7091 21.2024C40.8216 21.0118 40.7591 20.768 40.5685 20.6555C37.4997 18.843 33.481 19.2587 30.8404 21.8962C28.7466 23.9899 28.0529 26.9587 28.7622 29.6274L19.606 38.7837C19.5122 38.8774 19.5185 39.0305 19.6154 39.1274L24.9185 44.4305C25.0154 44.5274 25.1716 44.5337 25.2622 44.4399L34.4154 35.2868C37.0872 35.9993 40.056 35.3087 42.1529 33.2118C44.7904 30.5712 45.206 26.5524 43.3935 23.4837ZM40.5622 31.618C38.7466 33.4337 36.0216 33.7837 33.856 32.668L33.581 32.943L33.5779 32.9399L25.0154 41.5055L22.5404 39.0305L29.731 31.8399C29.731 31.8399 29.731 31.843 29.7341 31.843L31.3841 30.193C30.2685 28.0274 30.6185 25.3024 32.4341 23.4868C33.0197 22.9007 33.7249 22.4479 34.5015 22.1594C35.2781 21.8708 36.1079 21.7533 36.9341 21.8149L32.781 25.9649C32.5934 26.1527 32.488 26.4073 32.488 26.6727C32.488 26.9382 32.5934 27.1927 32.781 27.3805L36.6716 31.2712C36.8594 31.4588 37.114 31.5641 37.3794 31.5641C37.6449 31.5641 37.8994 31.4588 38.0872 31.2712L42.2372 27.1212C42.3529 28.7399 41.7872 30.3962 40.5622 31.618Z",
    fill: "#82838C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeContent);
export default __webpack_public_path__ + "static/media/ShapeContent.ad72fe85598a5405fe02404beea61d9c.svg";
export { ForwardRef as ReactComponent };